import { render, staticRenderFns } from "./FriendsSite.vue?vue&type=template&id=1615b908&scoped=true&"
import script from "./FriendsSite.vue?vue&type=script&lang=js&"
export * from "./FriendsSite.vue?vue&type=script&lang=js&"
import style0 from "./FriendsSite.vue?vue&type=style&index=0&id=1615b908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1615b908",
  null
  
)

export default component.exports